export default "__VITE_ASSET__BQJCXT_a__"